import { TokenStorage } from '../classes/token-storage'

export const tokenStorage = new TokenStorage()
